module.exports = __webpack_public_path__ + "static/media/Oswald-ExtraLight.d2dc2ce0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Oswald-ExtraLight.ttf
// module id = 6694
// module chunks = 2